module.exports = __webpack_public_path__ + "img/Event_1.40a5097c.jpg";